import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
	name: 'replaceTextPlaceholders'
} )
export class ReplaceTextPlaceholdersPipe implements PipeTransform {

	transform( text: string, replaceData: object ): string {
		if ( !replaceData ) { return text; }

		const output = text.replace( /%[^%]+%/g, (match) => {
			if (match in replaceData) {
				return(replaceData[match]);
			} else {
				return '';
			}
		});
		return output;
	}
}
